import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "82",
  height: "75",
  fill: "none",
  class: "auth-banner-butterfly",
  viewBox: "0 0 82 75"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<g fill=\"#FFF0F0\" clip-path=\"url(#clip0_6636_248705)\"><path d=\"M1.664 48.531c4.11-5.46 12.052-11.226 20.412-3.717a51 51 0 0 1-4.893-9.035c-5.071-12.576.431-20.464 7.163-28.494a75 75 0 0 1 3.718-4.142c3.5-3.668 6.48-3.647 10.614 2.734a80 80 0 0 1 7.796 15.549c3.029 8.364 2.944 16.194-2.256 23.956L25.624 66.597c-10.886 6.498-15.727.793-22.736-7.201C.02 55.732-1.273 52.43 1.663 48.53\"></path><path d=\"M40.337 68.805c4.768-5.115 9.896-12.353 3.694-12.45 2.587-.66 5.124-1.5 7.593-2.513 10.612-4.383 17.49-11.552 24.52-19.426a174 174 0 0 0 3.632-4.187c3.221-3.814 3.279-5.32-2.065-3.89a96.5 96.5 0 0 0-13.082 4.642c-7.066 3.09-13.756 7.47-20.519 14.416L25.519 66.612c-5.828 9.141-1.079 8.446 5.571 7.587 3.057-.569 5.843-1.74 9.249-5.394\"></path></g><defs><clipPath id=\"clip0_6636_248705\"><path fill=\"#fff\" d=\"M82 .67H0v74h82z\"></path></clipPath></defs>", 2)
  ])))
}
export default { render: render }